import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import Conversation from '../components/Conversation';

const ConversationCards = ({
  conversations,
  showEmptyState,
  filtered,
  onClearAllFilters,
}) => {
  if (showEmptyState) {
    if (filtered) {
      return (
        <div data-testid="empty-state" className="empty-conversation-results">
          <h3>No conversations found</h3>
          <p className="text-center">
            Try adjusting your filters or check back later to see if we've
            posted new conversations.
          </p>
          <Button
            onClick={onClearAllFilters}
            data-testid="clear-filters-button"
          >
            Clear all filters
          </Button>
        </div>
      );
    }
    return (
      <div data-testid="empty-state" className="empty-conversation-results">
        <h3>No conversations found</h3>
        <p className="text-center">
          Check back later to see if we've posted new conversations.
        </p>
      </div>
    );
  }
  return (
    <div data-testid="conversation-cards">
      {conversations.map((conversation, id) => (
        <Conversation key={id} shift={conversation} />
      ))}
    </div>
  );
};

Conversation.propTypes = {
  conversations: PropTypes.array,
  showEmptyState: PropTypes.bool,
  filtered: PropTypes.bool,
  onClearAllFilters: PropTypes.func,
};

export default ConversationCards;
